import { render, staticRenderFns } from "./field_edit.vue?vue&type=template&id=63054352&scoped=true"
import script from "./field_edit.vue?vue&type=script&lang=js"
export * from "./field_edit.vue?vue&type=script&lang=js"
import style0 from "./field_edit.vue?vue&type=style&index=0&id=63054352&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63054352",
  null
  
)

export default component.exports